import { logger } from '@/util';
import { DomainCode } from '@australiangreens/ag-internal-components';
import callBackendApi from './call';

export type ElectionState = 'VIC' | 'QLD' | 'TAS' | 'NSW' | 'SA' | 'WA' | 'NT' | 'ACT' | 'federal';

export interface ElectionElectoratePartRecord {
  id: number;
  name: string;
}

export interface ElectionRecord {
  id: number;
  name: string;
  shortname: string;
  kind: string;
  electionDate: Date;
  state: ElectionState;
  electorates: ElectionElectoratePartRecord[];
  taskprefix: string;
}

export const LIST_1093_HAS_ELECTORATES = true;

export const getElectionsContaining = async (
  token: string,
  containedString: string,
  domainCode: DomainCode,
  hasElectorates?: boolean,
  abortSignal?: AbortSignal
) => {
  logger.debug('getElectionsContaining() called', {});

  const hasElectoratesSuffix =
    hasElectorates === true
      ? '&hasElectorates=true'
      : hasElectorates === false
        ? '&hasElectorates=false'
        : '';

  const data = await callBackendApi({
    token,
    method: 'get',
    endpoint: `/elections/containing/${encodeURIComponent(
      containedString
    )}?domainCode=${domainCode}${hasElectoratesSuffix}`,
    abortSignal,
  });

  return data as ElectionRecord[];
};

export const getElectionById = async (
  token: string,
  electionId: number,
  abortSignal?: AbortSignal
) => {
  logger.debug('getElectionById() called', {});

  const data = await callBackendApi({
    token,
    method: 'get',
    endpoint: `/elections/${electionId}`,
    abortSignal,
  });
  return data as ElectionRecord;
};

export const getElectionsByIds = async (
  token: string,
  electionIds: number[],
  domainCode: DomainCode,
  abortSignal?: AbortSignal
) => {
  logger.debug('getElectionsById() called', {});

  const data = await callBackendApi({
    token,
    method: 'get',
    endpoint: `/elections?ids=${JSON.stringify(electionIds)}&domainCode=${domainCode}`,
    abortSignal,
  });
  return data as ElectionRecord[];
};
